export const EMAIL_REGEX = "^(.+)@(.+)$";

export function isValidEmail(str: unknown): str is string {
    if (typeof str !== "string") {
        return false;
    }
    const emailRegex = new RegExp(EMAIL_REGEX);
    return !!emailRegex.test(str);
}
